import React from "react";
import { ToastContainer } from "react-toastify";
import ViewSubCategory from "../../components/ProductManager/SubCategory/ViewSubCategory";

export const ViewSubCategoryPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewSubCategory />
        </div>
      </div>
    </div>
  );
};
